module.exports = __webpack_public_path__ + "img/p8.4cc07b96.png";